'use strict';

import {createElWithAttrs} from '@borngroup/born-utilities';

function _checkAttributes(elementList, attributeName, attributeValue) {
    return [].forEach.call(elementList, function(currentEl) {
        return currentEl.getAttribute(attributeName) === attributeValue;
    });
}

function _updateAvailabilityContainer(availabilityEls, response, available, ready) {
    [].forEach.call(availabilityEls, function(currentEl) {
        let availabilityListEl = currentEl.querySelector('[data-product-component="availability-list"]'),
            availabilityMessages = response.product.availability.messages;

        currentEl.setAttribute('data-available', available);
        currentEl.setAttribute('data-ready-to-order', ready);

        availabilityListEl.textContent = '';

        if (!ready) {
            _renderAvailabilityItem(availabilityListEl, response.resources.info_selectforstock);
        } else if (availabilityMessages && availabilityMessages.length) {
            availabilityMessages.forEach(_renderAvailabilityItem.bind(this, availabilityListEl));
        } else if (!available) {
            _renderAvailabilityItem(availabilityListEl, window.SFRA.Resources.noAvailability);
        }
    });
}

function _renderAvailabilityItem(availabilityListEl, message) {
    let newItem = createElWithAttrs(availabilityListEl, {class: 'product-availability__item'}, 'li');

    newItem.textContent = message;
}

/**
 * Updates the availability status.
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {HTMLElement} productContainer - DOM element for a given product
 */
export function updateAvailability(response, productContainer) {
    let availabilitySingleEls = productContainer.querySelectorAll('[data-product-component="single-availability"]'),
        availabilityGlobalEls = productContainer.querySelectorAll('[data-product-component="global-availability"]');

    $(productContainer).trigger('product:updateAvailability', {
        product: response.product,
        container: productContainer,
        resources: response.resources
    });

    _updateAvailabilityContainer(availabilitySingleEls, response, response.product.available, response.product.readyToOrder);

    if (availabilityGlobalEls.length) {
        let allAvailable = _checkAttributes(availabilitySingleEls, 'data-available', 'true'),
            allReady = _checkAttributes(availabilitySingleEls, 'data-ready-to-order', 'true');

        _updateAvailabilityContainer(availabilityGlobalEls, response, allAvailable, allReady);
    }
}
